'use client';

import LeadersItem from './LeadersItem/LeadersItem';
import leaders from 'data/leaders';

const Leaders = () => {
  return (
    <section className='leaders'>
      <div className='container'>
        <h3 className='subtitle'>Our leaders</h3>
        <h2 className='title'>We love what we do</h2>
        <p className='text'>
          Our leadership team has decades of collective experience in cybersecurity, software engineering, and technology management, bringing a diverse set of backgrounds and perspectives to the table.
        </p>
        <div className='leaders-grid'>
          {leaders.map((leader, index) => (
            <LeadersItem key={index} data={leader} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Leaders;

